import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import { loadFromLocalStorage } from 'utils/LocalStorageUtils';
import { saveToLocalStorage } from 'utils/LocalStorageUtils';
import languages from 'translations';
import { isEmpty } from 'utils/utils';

const ToggleSwitchLanguage = () => {
    const [isChecked, setIsChecked] = useState(false);
    const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
    const handleChange = (e) => {
        setIsChecked(e.target.checked);
        if (e.target.checked) {
            const lang = {
                language: languages.hindiLang,
                langCode: 'hi',
            }
            saveToLocalStorage("SELECTLANGUAGE", lang);
        } else {
            const lang = {
                language: languages.english,
                langCode: 'en',
            }
            saveToLocalStorage("SELECTLANGUAGE", lang);
        }
    };
    useEffect(() => {
        if (selectLang != undefined && !isEmpty(selectLang)) {
            if (selectLang?.langCode === 'hi') {
                setIsChecked(true);
            } else {
                setIsChecked(false);
            }
        } else {
            const lang = {
                language: languages.english,
                langCode: 'en',
            }
            saveToLocalStorage("SELECTLANGUAGE", lang);
        }
    }, [])
    return (
        // <Form>
        //     <Form.Check
        //         type="switch"
        //         id="custom-switch"
        //         // label="ही"
        //         checked={isChecked}
        //         onChange={handleChange}
        //         className="custom-switchlanguage"
        //     />
        // </Form>
        <label className="custom-switchlanguage switch-cstt">
            <input
                type="checkbox"
                checked={isChecked}
                onChange={handleChange}
            />
            <span className="slider round"></span>
        </label>
    );
};

export default ToggleSwitchLanguage;